import AnnouncementInfo from './AnnouncementInfo';

export default AnnouncementInfo;
